export default {
    MODAL: {
        OPEN: 'open',
        CLOSED: 'closed'
    },
    MENU: {
        OPEN: 'open',
        CLOSED: 'closed'
    },
    ITEM_LAYOUT: {
        GRID: 'layout-grid',
        LIST: 'layout-list'
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/constants/state.js